import React from "react";

import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import TermsAndConditionsScreen from "@scenes/authentication/TermsAndConditions";

const TermsAndConditionsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      size={"lg"}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      paddingTop={16}
      headerTitle={t("navigation.profile.general.label.terms")}
    >
      <TermsAndConditionsScreen onMoreScreen={true} />
    </Modal>
  );
};

export default TermsAndConditionsModal;
